import PrimaryDualList from './PrimaryDualList';
export default PrimaryDualList;

